import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import gundi_not_found from '../../images/gundi_no_results_green.png';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    // mt-[3px]: the app shell's pt-[115px] leaves 29px below the 86px nav;
    // design spec asks for a 32px gap between the nav and this card.
    <div
      data-testid="NotFoundPage-container"
      className="mx-auto mt-[3px] flex max-w-list-table flex-row items-start gap-6 rounded-lg bg-greyscale-10 p-8"
    >
      <img src={gundi_not_found} alt="" className="h-[120px] shrink-0" />
      <div>
        <h1 className="mb-1 text-2xl font-normal text-ui-text-primary-text">
          {t('404: Page not found')}
        </h1>
        <p className="mb-4 text-base font-normal text-ui-text-primary-text">
          {t(
            "The page you are looking for doesn't exist, has been temporarily disabled, or was relocated.",
          )}
        </p>
        <button
          type="button"
          data-testid="NotFoundPage-button"
          className="flex h-9 items-center justify-center rounded bg-white px-3 py-2 text-base font-semibold text-ui-cta-primary transition-colors duration-300 hover:bg-unlisted-neutral-gray-50"
          onClick={() => navigate('/', { replace: true })}
        >
          {t('Go to Routes Overview')}
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
